import { render, staticRenderFns } from "./CompanionActionsMenu.vue?vue&type=template&id=27c0dfc7&scoped=true&lang=pug&"
import script from "./CompanionActionsMenu.vue?vue&type=script&lang=js&"
export * from "./CompanionActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompanionActionsMenu.vue?vue&type=style&index=0&id=27c0dfc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0dfc7",
  null
  
)

export default component.exports